var level0Task0 = `
<xml xmlns="https://developers.google.com/blockly/xml" id="workspaceBlocks" style="display: none">
  <block type="text_print" id="[t3U4q7.HGBWkOCgxuol" x="38" y="113">
    <value name="TEXT">
      <block type="text" id="b#.?p*{%jbSYt)Btd2tP">
        <field name="TEXT">Hello World</field>
      </block>
    </value>
  </block>
</xml>
`
export default level0Task0
